import { DropdownItem } from '../components/common-header/dropdown-list/dropdown-list';

interface IHttpResponse<T> {
  items: T[];
  links: ILink[];
}

interface ILink {
  rel: string;
  href: string;
}

interface IInstance {
  InstanceId: string;
  InstanceName: string | null;
  InstanceNickname: string | null;
  IsHomeOrganization?: boolean;
  IsService?: boolean;
  Region: string;
  GroupName: string;
  GroupId: string;
  ProductId: string;
  ProductName: string;
  ProductType: string;
  OrganizationName: string;
  OrganizationId: string;
  UserPermissions: { Roles: any[]; Tags: any[] };
  NavigationUrl: string;
}

interface ProductSwitcherProps {
  organizations: DropdownItem[];
  products: DropdownItem[];
}

export const transformInstanceListToHierarchy = (instancesResponse: IHttpResponse<IInstance>): ProductSwitcherProps => {
  const { items: allItems } = instancesResponse;
  const items = (allItems || []).filter(item => !item.IsService);

  let organizations: DropdownItem[] = [];
  let products: DropdownItem[] = [];

  if (items.length < 1) {
    return {
      organizations: [],
      products: [],
    };
  }

  items.forEach(item => {
    const itemOrg = organizations.find(org => org.value === item.OrganizationId);
    const itemProduct = products.find(product => product.value === item.ProductId && product.valueObject.OrganizationId === item.OrganizationId);

    if (!itemOrg) {
      organizations.push({
        text: item.OrganizationName,
        value: item.OrganizationId,
        type: 'organization',
        rightIcon: item.IsHomeOrganization ? "home" : null
      });
    }

    if (!itemProduct) {
      products.push({
        text: item.ProductName,
        value: item.ProductId,
        valueObject: item,
        subItems: [
          {
            text: item.InstanceNickname || item.InstanceName,
            href: item.NavigationUrl ? item.NavigationUrl : null,
            value: item.InstanceId,
            valueObject: item,
            type: 'instance',
          },
        ],
        type: 'product',
      });
    } else {
      itemProduct.subItems.push({
        text: item.InstanceNickname || item.InstanceName,
        href: item.NavigationUrl ? item.NavigationUrl : null,
        value: item.InstanceId,
        valueObject: item,
        type: 'instance',
      });
    }
  });

  // alphabetize list of orgs
  organizations.sort((orgA, orgB) => orgA.text.localeCompare(orgB.text));

  return {
    organizations,
    products,
  };
};
